"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirmwarePartT = exports.FirmwarePart = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class FirmwarePart {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsFirmwarePart(bb, obj) {
        return (obj || new FirmwarePart()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsFirmwarePart(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new FirmwarePart()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    url(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    /**
     * Offset of the firmware, used when flashing to the mcu, it indicates where to write this file in memory
     * Will be ignored in the case of OTA flashing
     */
    offset() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    digest(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    static startFirmwarePart(builder) {
        builder.startObject(3);
    }
    static addUrl(builder, urlOffset) {
        builder.addFieldOffset(0, urlOffset, 0);
    }
    static addOffset(builder, offset) {
        builder.addFieldInt32(1, offset, 0);
    }
    static addDigest(builder, digestOffset) {
        builder.addFieldOffset(2, digestOffset, 0);
    }
    static endFirmwarePart(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createFirmwarePart(builder, urlOffset, offset, digestOffset) {
        FirmwarePart.startFirmwarePart(builder);
        FirmwarePart.addUrl(builder, urlOffset);
        FirmwarePart.addOffset(builder, offset);
        FirmwarePart.addDigest(builder, digestOffset);
        return FirmwarePart.endFirmwarePart(builder);
    }
    unpack() {
        return new FirmwarePartT(this.url(), this.offset(), this.digest());
    }
    unpackTo(_o) {
        _o.url = this.url();
        _o.offset = this.offset();
        _o.digest = this.digest();
    }
}
exports.FirmwarePart = FirmwarePart;
class FirmwarePartT {
    constructor(url = null, offset = 0, digest = null) {
        this.url = url;
        this.offset = offset;
        this.digest = digest;
    }
    pack(builder) {
        const url = (this.url !== null ? builder.createString(this.url) : 0);
        const digest = (this.digest !== null ? builder.createString(this.digest) : 0);
        return FirmwarePart.createFirmwarePart(builder, url, this.offset, digest);
    }
}
exports.FirmwarePartT = FirmwarePartT;
